import { isElementNode } from 'anodum';
import isInlineElement from './is-inline-element';

const isBlockElement = (element) => isElementNode(element) && !isInlineElement(element);

export default isBlockElement;
